import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../lib/constants';
import { trackInitiateCheckout } from '../lib/pixel';
type SectionCtaProps = {
  /** The transformational promise shown on the button. */
  label: string;
  note?: string;
  tone?: 'light' | 'dark';
};
export function SectionCta({
  label,
  note,
  tone = 'light'
}: SectionCtaProps) {
  const isDark = tone === 'dark';
  return <div className="mt-8 flex flex-col items-center" data-id="element-199" data-mp="38mklpp0wavxh">
      <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} className={`group flex w-full max-w-md items-center justify-center gap-2 rounded-2xl border-2 px-4 py-3.5 text-center text-[13px] font-extrabold uppercase leading-tight tracking-wide transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-400/50 sm:text-[15px] ${isDark ? 'border-gold-500 bg-gold-500 text-navy-950 hover:bg-gold-400' : 'border-navy-900 bg-navy-900 text-white hover:bg-navy-700'}`} data-id="element-200" data-mp="3dec61htgk5f6">
        <span className="break-words" data-id="element-201" data-mp="1fphyuivx3lw1">{label}</span>
        <ChevronRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-202" data-mp="1ashpnz3ru30p" />
      </a>
      <p className={`mt-2.5 text-center text-[11px] font-semibold uppercase tracking-[0.1em] ${isDark ? 'text-cream-200/80' : 'text-navy-800/55'}`} data-id="element-203" data-mp="1opep2oxygst7">
        {note ?? 'Acceso inmediato · Pago único · USD 15'}
      </p>
    </div>;
}